<template>
  <div class="product-menu">
    <img class="banner" src="../assets/product/product-banner3.png" />
    <div class="body topic-color">
      <div class="header content">产品菜谱</div>
      <div class="list row" ref="container">
        <van-sticky :container="container">
          <div class="one col">
            <div
              class="one-item row"
              v-for="one in oneCatList"
              :key="one.id"
              @click="onChange(one.id)"
            >
              <img class="icon" :src="one.icon_url" />
              <span class="small-content">{{ one.name }}</span>
              <img
                v-if="active === one.id"
                class="arrow"
                src="../assets/jiantou.png"
              />
            </div>
          </div>
        </van-sticky>

        <div class="two col">
          <div
            class="two-item-block"
            v-for="(two, index) in twoCatList"
            :key="two.id"
            v-bind:class="{
              first: index === 0,
              last: index + 1 === twoCatList.length,
              'bg-green': [25, 21, 22, 47, 54, 55, 56].indexOf(two.id) > -1,
            }"
          >
            <div
              class="two-item row"
              v-bind:class="{
                'item-bottom-line': index + 1 < twoCatList.length,
                'bg-green': [25, 21, 22, 47].indexOf(two.id) > -1,
              }"
            >
              <!-- <img
                class="fat-0"
                v-if="two.id === 25 || two.id === 54"
                src="../assets/product-menu/qingmei.png"
              />
              <img
                class="fat-0"
                v-if="two.id === 21 || two.id === 55"
                src="../assets/product-menu/yangcong.png"
              />
              <img
                class="fat-0"
                v-if="two.id === 22"
                src="../assets/product-menu/qiandao.png"
              />
              <img
                class="fat-0"
                v-if="two.id === 47 || two.id === 56"
                src="../assets/product-menu/ningmeng.png"
              />
              <img
                class="new"
                v-if="two.id === 46"
                src="../assets/product-menu/new.png"
              /> -->
              <img class="icon" :src="two.icon_url" />
              <div class="col">
                <div class="small-content">{{ two.name }}</div>
                <div class="xs-content description">{{ two.description }}</div>
                <div
                  class="button xs-content"
                  @click="
                    $router.push({
                      name: 'cat_menu_list',
                      params: { category_id: two.id },
                    })
                  "
                >
                  全部菜谱
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <go-home></go-home>
    <wechat-share></wechat-share>
  </div>
</template>

<script>
import goHome from "../components/goHome";
import wechatShare from "../components/wechatShare";
export default {
  name: "product_menu",
  components: {
    goHome,
    wechatShare,
  },
  data() {
    return {
      banner_url: "",
      oneCatList: [],
      twoCatList: [],
      active: "",
      container: null,
    };
  },
  created() {
    var that = this;
    that.getOneCat();
  },
  mounted() {
    this.container = this.$refs.container;
  },
  computed: {
    oneHeight: function () {
      //document.getElementsByClassName('one')[0].style.length = document.getElementsByClassName('two')[0].style.height;
      //document.getElementsByClassName("one")[0].style.height = document.getElementsByClassName("two")[0].style.height;
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "cat_menu_list") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    getOneCat() {
      var that = this;
      that
        .$get("product_menu_ones")
        .then((res) => {
          if (res.code === 200) {
            that.oneCatList = res.data;
            that.active = that.oneCatList[0].id;
            that.getTwoCat(that.active);
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },
    getTwoCat(one_cat_id) {
      var that = this;
      that
        .$get("product_menu_twos", {
          one_cat_id: one_cat_id,
        })
        .then((res) => {
          if (res.code === 200) {
            that.twoCatList = res.data;
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },
    onChange(one_cat_id) {
      var that = this;
      if (that.active !== one_cat_id) {
        that.active = one_cat_id;
        that.getTwoCat(one_cat_id);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.product-menu {
  color: #ee7060;
  .banner {
    width: 100%;
    z-index: -1;
  }
  .body {
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    position: relative;
    top: -60px;
    background-color: white;
    padding: 30px 20px;
    .header {
      padding: 20px 0 15px 30px;
      text-align: start;
      border-bottom: 5px solid #fceeef;
      font-weight: 700;
    }
    .list {
      margin-top: 30px;
      margin-left: 30px;
      align-items: start;
      justify-content: flex-end;

      /deep/.van-sticky--fixed {
        width: 187px;
        left: 50px;
      }
      .one {
        width: 200px;
        padding-top: 30px;
        .one-item {
          position: relative;
          height: 150px;
          .icon {
            width: 30%;
          }
          span {
            width: 60%;
          }
          .arrow {
            width: 24px;
            position: absolute;
            right: 0;
          }
        }
      }

      .two {
        width: 480px;
        border-radius: 50px;
        min-height: 600px;
        box-sizing: border-box;
        .two-item-block {
          padding: 10px 30px 0;
          background-color: #fcefef;
        }
        .two-item-block-green {
          padding: 10px 30px;
          background-color: #effffc;
        }
        .two-item {
          padding: 30px 10px 60px;
          position: relative;
          .fat-0 {
            position: absolute;
            left: 0;
            width: 35px;
          }
          .new {
            position: absolute;
            left: -10px;
            width: 45px;
            top: 50px;
          }
          .icon {
            width: 90px;
            margin-right: 20px;
          }
          .col {
            align-items: start;
            text-align: start;
            .description {
              text-align: start;
            }
            .button {
              border-radius: 50px;
              background-color: #ee7060;
              color: white;
              padding: 0 10px;
              position: absolute;
              right: 0;
              bottom: 20px;
            }
          }
        }
        .item-bottom-line {
          border-bottom: 3px solid #f9dcdc;
        }
        .bg-green {
          background-color: #effffc;
        }
        .first {
          border-top-left-radius: 50px;
          border-top-right-radius: 50px;
        }
        .last {
          border-bottom-left-radius: 50px;
          border-bottom-right-radius: 50px;
        }
      }
    }
  }
}
</style>
